import {
  getPostFlowUrl,
  getReturnUrlFromRequestLoader,
} from 'utils/common/route';
import { getParamsFromStoreRedux } from 'store/utils';
import { redirect } from 'react-router-dom';
import { isAuthed } from 'utils/common/session';
import { ensureUserInfoLoaded } from 'utils/loaderUtils';
import { defineRulesFor, defineRulesForWorkflow } from 'common/casl/ability';
import { queryBrandingNavigation } from 'hooks';

export const creditCardInfoLoader =
  (queryClient, ability) =>
  async ({ request }) => {
    const { dispatch } = getParamsFromStoreRedux();

    const returnUrl = getReturnUrlFromRequestLoader(request) || '/';
    const isAuthenticated = isAuthed();

    const { userInfo } = await ensureUserInfoLoaded({
      queryClient,
      returnUrl,
    });
    const hasCreditCard = userInfo?.hasCreditCard;

    if (isAuthenticated) {
      // Only after EULA is confirmed, continue with other logic
      try {
        let brandingData = null;

        if (userInfo?.id) {
          const brandingResponse = await queryBrandingNavigation({
            queryClient,
            userId: userInfo.id,
          });
          brandingData = brandingResponse?.data;
        }

        if (userInfo && brandingData) {
          const workflowRoles = userInfo?.workflowRoles ?? [];

          const permissionRules = defineRulesFor(userInfo, brandingData);
          const workflowRules = defineRulesForWorkflow(
            userInfo,
            workflowRoles,
            brandingData
          );
          const rules = [...permissionRules, ...workflowRules];
          ability.update(rules);
        }
      } catch (error) {
        console.error('Failed to load branding or set permissions:', error);
      }
    }

    if (hasCreditCard) {
      const redirectUrl = getPostFlowUrl({
        type: 'check-credit-card-info',
        returnUrl,
        dispatch,
      });
      throw redirect(redirectUrl);
    }

    return {
      userInfo,
      hasCreditCard,
      returnUrl,
      timestamp: new Date(),
    };
  };
